import { OrganisationDataDto } from '@dhl/mdp-api'
import type { TerminalData } from '~/modules/terminals/model'
import { convertToAddressDto } from '~/common/components/addresses'
import { convertToContactPersonDto } from '~/common/model/contact'

export const convertToTerminalDataDto = (terminalData: TerminalData): OrganisationDataDto => ({
  ...terminalData,
  address: convertToAddressDto(terminalData.address),
  contactPerson: convertToContactPersonDto(terminalData.contactPerson),
})
